import React, { FC } from 'react';
import 'react-phone-number-input/style.css';
import { Controller } from 'react-hook-form';
import PhoneInput from 'react-phone-number-input';
import '../form.scss';

type Country = 'US' | 'CA'; // Add more country codes if needed

interface CustomPhoneInputProps {
  name: string;
  label?: string;
  wrapperClass?: string;
  className?: string;
  defaultCountry?: Country;
  control?: any;
  errors?: any;
  placeholder?: string;
  labelClass?: string;
  disabled?: boolean;
}

const CustomPhoneInput: FC<CustomPhoneInputProps> = ({
  name,
  label,
  wrapperClass,
  className,
  defaultCountry,
  control,
  errors,
  placeholder,
  labelClass,
  disabled
}) => {
  return (
    <div className={`${wrapperClass} flex flex-col items-start pb-4 text-sm`}>
      {label && (
        <label className={`${labelClass} text-neutral9 font-semibold`} htmlFor={name}>
          {label}
        </label>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <PhoneInput
            international
            defaultCountry={defaultCountry}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            className={`${className}`}
            disabled={disabled}
          />
        )}
      />
      {errors && errors[name] && (
        <span className="error" role="alert">
          {errors[name]?.message}
        </span>
      )}
    </div>
  );
};

export default CustomPhoneInput;
